import {
  faAppleAlt,
  faBrain,
  faBuilding, faBuildingColumns,
  faCookie,
  faCrown,
  faDroplet,
  faHandsHelping,
  faHeartPulse,
  faHospital,
  faHouseMedical,
  faLungs,
  faPills,
  faRunning,
  faStethoscope,
  faTemperatureFull,
  faTooth,
  faUserDoctor,
  faUserNurse,
  faUserTie
} from "@fortawesome/free-solid-svg-icons";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {
  BUSINESS_CATEGORY_COLOR_BY_PATH,
  METRIC_COLOR_BY_KEY,
  ORGANIZATION_COLOR_BY_NAME,
  ROLE_BG_GRADIENT_BY_VALUE,
  STATUS_COLOR_BY_NAME,
  VACCINE_COLOR_BY_NAME,
} from "../designSystem/tokens/colors";
import {PIE_CHART_COLORS as PIE_CHART_COLOR_TOKENS} from "../designSystem/tokens/chart";

// VACCINES
export const VACCINE_TYPES = [
  {name: '不限', shortName: '', color: ''},
  {name: 'M痘疫苗', shortName: 'M痘', color: VACCINE_COLOR_BY_NAME['M痘疫苗']},
  {name: '卡介苗', shortName: '卡', color: VACCINE_COLOR_BY_NAME['卡介苗']},
  {name: '肺炎鏈球菌疫苗', shortName: '肺', color: VACCINE_COLOR_BY_NAME['肺炎鏈球菌疫苗']},
  {name: '流感疫苗', shortName: '流', color: VACCINE_COLOR_BY_NAME['流感疫苗']},
  {name: '常規疫苗', shortName: '常', color: VACCINE_COLOR_BY_NAME['常規疫苗']},
  {name: '新冠肺炎疫苗', shortName: '新', color: VACCINE_COLOR_BY_NAME['新冠肺炎疫苗']},
  {name: 'HPV公費疫苗', shortName: 'HPV', color: VACCINE_COLOR_BY_NAME['HPV公費疫苗']},
]

export const VACCINE_TYPE_OPTIONS = VACCINE_TYPES.map(v => ({
  label: v.name,
  value: v.name,
}));

export const VACCINE_TYPE_MAP = VACCINE_TYPES.reduce((acc, item) => {
  acc[item.name] = {
    shortName: item.shortName,
    color: item.color,
  };
  return acc;
}, {});


// ORGANIZATION TYPES
export const ORGANIZATION_TYPES = [
  {name: '不限', icon: null, color: ''},
  {name: '醫院', icon: faHospital, color: ORGANIZATION_COLOR_BY_NAME['醫院']},
  {name: '西醫', icon: faStethoscope, color: ORGANIZATION_COLOR_BY_NAME['西醫']},
  {name: '中醫', icon: faHouseMedical, color: ORGANIZATION_COLOR_BY_NAME['中醫']},
  {name: '牙醫', icon: faTooth, color: ORGANIZATION_COLOR_BY_NAME['牙醫']},
  {name: '藥局', icon: faPills, color: ORGANIZATION_COLOR_BY_NAME['藥局']},
  {name: '中心', icon: faBuilding, color: ORGANIZATION_COLOR_BY_NAME['中心']},
  {name: '衛生所', icon: faBuildingColumns, color: ORGANIZATION_COLOR_BY_NAME['衛生所']},
];

export const ORGANIZATION_TYPE_OPTIONS = ORGANIZATION_TYPES.map(ot => ({
  label: ot.name,
  value: ot.name,
}));

export const ORGANIZATION_TYPE_MAP = ORGANIZATION_TYPES.reduce((acc, item) => {
  acc[item.name] = {
    icon: item.icon,
    color: item.color,
  };
  return acc;
}, {});

export const BADGE_COLOR = {
  ...VACCINE_TYPE_MAP,
  ...ORGANIZATION_TYPE_MAP,
}

export const ONLINE_RESERVATION_TYPES = [
  {label: '不限', value: '不限'},
  {label: '可線上掛號', value: '可線上掛號'},
]

export const REGION_OPTIONS = [
  {label: '不限', value: '不限'},
  {label: '屏東市', value: '屏東市'},
  {label: '潮州鎮', value: '潮州鎮'},
  {label: '內埔鄉', value: '內埔鄉'},
  {label: '萬丹鄉', value: '萬丹鄉'},
  {label: '東港鎮', value: '東港鎮'},
  {label: '新園鄉', value: '新園鄉'},
  {label: '恆春鎮', value: '恆春鎮'},
  {label: '長治鄉', value: '長治鄉'},
  {label: '里港鄉', value: '里港鄉'},
  {label: '鹽埔鄉', value: '鹽埔鄉'},
  {label: '枋寮鄉', value: '枋寮鄉'},
  {label: '高樹鄉', value: '高樹鄉'},
  {label: '九如鄉', value: '九如鄉'},
  {label: '萬巒鄉', value: '萬巒鄉'},
  {label: '佳冬鄉', value: '佳冬鄉'},
  {label: '林邊鄉', value: '林邊鄉'},
  {label: '竹田鄉', value: '竹田鄉'},
  {label: '崁頂鄉', value: '崁頂鄉'},
  {label: '琉球鄉', value: '琉球鄉'},
  {label: '麟洛鄉', value: '麟洛鄉'},
  {label: '南州鄉', value: '南州鄉'},
  {label: '新埤鄉', value: '新埤鄉'},
  {label: '車城鄉', value: '車城鄉'},
  {label: '三地門鄉', value: '三地門鄉'},
  {label: '來義鄉', value: '來義鄉'},
  {label: '滿州鄉', value: '滿州鄉'},
  {label: '瑪家鄉', value: '瑪家鄉'},
  {label: '泰武鄉', value: '泰武鄉'},
  {label: '枋山鄉', value: '枋山鄉'},
  {label: '春日鄉', value: '春日鄉'},
  {label: '獅子鄉', value: '獅子鄉'},
  {label: '牡丹鄉', value: '牡丹鄉'},
  {label: '霧臺鄉', value: '霧臺鄉'},
]

export const GENDER_OPTIONS = [
  {label: '男', value: '男'},
  {label: '女', value: '女'},
]

// BUSINESS CATEGORIES
const BUSINESS_CATEGORIES = [
  { name: '居家醫療', shortName: '居醫', group: '居家醫療組', color: BUSINESS_CATEGORY_COLOR_BY_PATH.homeMedicalCare.color, path: 'homeMedicalCare', icon: faHouseMedical, badgeColor: BUSINESS_CATEGORY_COLOR_BY_PATH.homeMedicalCare.badgeColor},
  { name: '到宅牙醫', shortName: '牙醫', group: '到宅牙醫', color: BUSINESS_CATEGORY_COLOR_BY_PATH.homeDentalCare.color, path: 'homeDentalCare', icon: faTooth, badgeColor: BUSINESS_CATEGORY_COLOR_BY_PATH.homeDentalCare.badgeColor},
  { name: '居家護理', shortName: '居護', group: '居家護理組', color: BUSINESS_CATEGORY_COLOR_BY_PATH.homeNursingCare.color, path: 'homeNursingCare', icon: faUserNurse, badgeColor: BUSINESS_CATEGORY_COLOR_BY_PATH.homeNursingCare.badgeColor},
  { name: '行動藥師', shortName: '藥事', group: '藥事服務組', color: BUSINESS_CATEGORY_COLOR_BY_PATH.mobilePharmacist.color, path: 'mobilePharmacist', icon: faPills, badgeColor: BUSINESS_CATEGORY_COLOR_BY_PATH.mobilePharmacist.badgeColor},
  { name: '行動營養師', shortName: '營養', group: '保健營養組', color: BUSINESS_CATEGORY_COLOR_BY_PATH.mobileDietitian.color, path: 'mobileDietitian', icon: faAppleAlt, badgeColor: BUSINESS_CATEGORY_COLOR_BY_PATH.mobileDietitian.badgeColor},
  { name: '行動心理師', shortName: '心理', group: '心理諮商組', color: BUSINESS_CATEGORY_COLOR_BY_PATH.mobilePsychologist.color, path: 'mobilePsychologist', icon: faBrain, badgeColor: BUSINESS_CATEGORY_COLOR_BY_PATH.mobilePsychologist.badgeColor},
  { name: '行動復能', shortName: '復能', group: '行動復能', color: BUSINESS_CATEGORY_COLOR_BY_PATH.mobileRehabilitation.color, path: 'mobileRehabilitation', icon: faRunning, badgeColor: BUSINESS_CATEGORY_COLOR_BY_PATH.mobileRehabilitation.badgeColor},
  { name: '長照居家', shortName: '長照', group: '長期照顧組', color: BUSINESS_CATEGORY_COLOR_BY_PATH.homeServices.color, path: 'homeServices', icon: faHandsHelping, badgeColor: BUSINESS_CATEGORY_COLOR_BY_PATH.homeServices.badgeColor},
]

export const CATEGORIES = BUSINESS_CATEGORIES.map(bc => ({
  label: bc.name,
  color: bc.color,
  path: bc.path,
  icon: bc.icon,
  badgeColor: bc.badgeColor,
}))

export interface Group {
  name: string;
  shortName: string;
  color: string;
  path: string;
  icon: IconProp
}

export interface TMetric {
  key: string;
  label: string;
  icon: IconProp;
  color: string;
}

export const GROUPS: Group[] = BUSINESS_CATEGORIES.map(bc => ({
  name: bc.group,
  shortName: bc.shortName,
  color: bc.badgeColor,
  path: bc.path,
  icon: bc.icon,
}))

export const CATEGORIES_MAPPING = Object.fromEntries(
  BUSINESS_CATEGORIES.map(item => [item.path, item.name])
);

export const ROLES = [
  {
    label: '總管理',
    value: 'god',
    icon: faCrown,
    canManageRoles: ['god'],
    bgGradient: ROLE_BG_GRADIENT_BY_VALUE.god
  },
  {
    label: '科室人員',
    value: 'admin',
    icon: faUserTie,
    canManageRoles: ['god', 'admin'],
    bgGradient: ROLE_BG_GRADIENT_BY_VALUE.admin
  },
  {
    label: '機構人員',
    value: 'worker',
    icon: faUserDoctor,
    canManageRoles: ['god', 'admin'],
    bgGradient: ROLE_BG_GRADIENT_BY_VALUE.worker
  },
  {
    label: '無',
    value: '',
    icon: null,
    canManageRoles: ['god', 'admin'],
    bgGradient: ROLE_BG_GRADIENT_BY_VALUE['']
  },
];

export const STATUS = [
  { name: 'processing', label: '待派案', color: STATUS_COLOR_BY_NAME.processing},
  { name: 'assigned', label: '指定派案', color: STATUS_COLOR_BY_NAME.assigned},
  { name: 'accept', label: '已接案', color: STATUS_COLOR_BY_NAME.accept},
  { name: 'completed', label: '已結案', color: STATUS_COLOR_BY_NAME.completed},
  { name: 'rejected', label: '不符合資格', color: STATUS_COLOR_BY_NAME.rejected},
  { name: 'noDemand', label: '評估後無需求', color: STATUS_COLOR_BY_NAME.noDemand},
  { name: 'dead', label: '已去世', color: STATUS_COLOR_BY_NAME.dead},
];

export const STATUS_MAP = STATUS.reduce((acc, item) => {
  acc[item.name] = {
    label: item.label,
    color: item.color,
  };
  return acc;
}, {});

export const STATUS_OPTIONS = STATUS.map(s => ({
  label: s.label,
  value: s.name,
}));

export const PIE_CHART_COLORS = PIE_CHART_COLOR_TOKENS;

export const DEFAULT_RULE = {
  id: '',
  name: '規則',
  enabled: false,
  priority: 100,
  match: {
    type: 'exact',
    keywords: [''],
  },
  responses: [
    {
      type: 'text',
      payload: {
        text: '',
      }
    }
  ],
  createdAt: '',
  updatedAt: '',
}

export const METRICS: TMetric[] = [
  {key: 'bp', label: '血壓', icon: faDroplet, color: METRIC_COLOR_BY_KEY.bp},
  {key: 'glucose', label: '血糖', icon: faCookie, color: METRIC_COLOR_BY_KEY.glucose},
  {key: 'temp', label: '體溫', icon: faTemperatureFull, color: METRIC_COLOR_BY_KEY.temp},
  {key: 'pulse', label: '脈搏', icon: faHeartPulse, color: METRIC_COLOR_BY_KEY.pulse},
  {key: 'oxygen', label: '血氧', icon: faLungs, color: METRIC_COLOR_BY_KEY.oxygen},
];

export const PERMISSIONS = [
  {name: 'medicalOrganizationManagement', label: '就醫資訊管理', default: false},
  {name: 'contentManagement', label: '衛教資訊管理', default: false},
  {name: 'robotManagement', label: '聊天機器人', default: false},
  {name: 'measurementManagement', label: '生理量測系統', default: false},
  {name: 'bsrs', label: 'BSRS系統', default: false},
  {name: 'databaseManagement', label: '備份管理', default: false},
  {name: 'contact', label: '業務窗口資訊', default: true},
  {name: 'systemInfo', label: '系統資訊', default: true},
  {name: 'storyBoard', label: '開發元件庫', default: false},
  {name: 'auditLog', label: '系統編輯紀錄', default: false},
]

export const PERMISSION_LABEL_MAPPING = PERMISSIONS.reduce((acc, curr) => {
  acc[curr.name] = curr.label;
  return acc;
}, {});

export const ACTION_MAPPING = {
  U: '更新',
  C: '新增',
  D: '刪除',
  R: '讀取',
};

export const SERVICE_CHECK_ITEMS_MAPPING = {
  barthelIndexLessThan60: '失能：巴氏量表 (Bathel ADL Index) 小於60分',
  hasAnyTube: '個案是否有三管路其中之一: (鼻胃管、氣切管、尿管)',
  hasDementia50Plus: '50歲以上失智症',
  hasNhiCard: '有健保卡',
  hasSevereDisability: '特定身心障礙手冊（重度）只能維持有限之自我照顧能力，清醒時50%以上活動限制在床上或椅子上',
  isDisabledIndigenous55Plus: '55歲以上失能原住民',
  isDisabledIndividual: '失能身心障礙者',
  isDisabledSenior65Plus: '65歲以上失能老人',
  isDisabledSenior65PlusOrIndigenous55Plus: '65歲以上(原民55歲以上)之長者',
  isFrailElderlyLivingAlone: '日常生活需他人協助的獨居老人身衰弱老人',
  isHomeBoundDisabled: '居家失能個案(能親自至醫院回診者不受理)',
  isLongTermBedridden: '長期個案因疾病、傷病長期臥床的狀態，清醒時50%以上活動限制在床上或椅子上',
  isMobilityImpairedLivingAlone: '行動不便的獨居者',
  isNotReceivingHomeRehabilitation: '個案本身不符合申請長照專業服務的資格，例如：IADLs 復能、ADLs 復能照護，或臥床／長期活動受限照護等',
  isPatientAgree: '本人同意',
  isReceivingPalliativeCare: '末期個案之安寧護理(需有安寧診斷)',
  isUnableToCollectMedication: '行動不便或有其他疾病等原因，親友無法代其領藥者。',
  livingAtHome: '居住於家中，無常進出醫療院所或安養長照機構',
  notAbleToGoToHospital: '個案為無法或困難前往醫療院所者(如:獨居、雙老、家屬在外縣市)，能親自至醫療院所回診者不受理',
  notIncludedAboveButHasNeed: '以上兩項未包含，但評估確有需求者',
  preciseMedicalNeed: '有明確醫療需求，失能或疾病外出不便。',
  regionRestrictedA: '個案居住地區為其中之一：新園鄉、麟洛鄉及屏東市',
}

export const SERVICE_CHECK_ITEMS = {
  homeMedicalCare: ['hasNhiCard', 'livingAtHome', 'preciseMedicalNeed', 'barthelIndexLessThan60'],
  homeDentalCare: ['hasNhiCard', 'livingAtHome', 'regionRestrictedA', 'isLongTermBedridden' ,'hasSevereDisability'],
  homeNursingCare: ['hasNhiCard', 'livingAtHome', 'hasAnyTube', 'preciseMedicalNeed', 'barthelIndexLessThan60', 'isReceivingPalliativeCare'],
  mobilePharmacist: ['isMobilityImpairedLivingAlone', 'isUnableToCollectMedication', 'notIncludedAboveButHasNeed'],
  mobileDietitian: ['isDisabledSenior65PlusOrIndigenous55Plus', 'isHomeBoundDisabled'],
  mobilePsychologist: ['isPatientAgree', 'notAbleToGoToHospital'],
  mobileRehabilitation: ['isNotReceivingHomeRehabilitation', 'notAbleToGoToHospital'],
  homeServices: ['isDisabledSenior65Plus', 'isDisabledIndigenous55Plus', 'hasDementia50Plus', 'isDisabledIndividual', 'isFrailElderlyLivingAlone'],
}

export const APPLICATION_ATTACHMENTS = {
  nhiCard: {bucket: 'nhiCards', label: '健保卡'},
  disabilityCertFront: {bucket: 'disabilityCertFront', label: '身障手冊正面'},
  disabilityCertBack: {bucket: 'disabilityCertBack', label: '身障手冊反面'},
  carePlan: {bucket: 'carePlans', label: '照顧管理評量/照顧計畫'},
  carePlanWithTransit: {bucket: 'carePlans', label: '照顧管理評量/照顧計畫/長者心健康量表篩檢轉介單'},
  barthelIndex: {bucket: 'barthelIndexes', label: '巴氏量表'},
  taiwaneseIdFront: {bucket: 'taiwaneseIdFront', label: '服務使用者國民身分證正面'},
  taiwaneseIdBack: {bucket: 'taiwaneseIdBack', label: '服務使用者國民身分證反面'},
}

export const LIFF_IDS = {
  APPLICATION_PAGE: {
    development: '2006775109-rNBdDno1',
    production: '2006775109-pPdKNL63',
  },
  MEASURE_PAGE: {
    development: '2006775109-DeOZAiDA',
    production: '2006775109-B028dvKW',
  },
  PLATFORM_PAGE: {
    development: '2006775109-1GXD6wdn',
    production: '2006775109-3dYxw0Nq',
  },
  CONSULTING_PAGE: {
    development: '2006775109-VKZWyE8q',
    production: '2006775109-VKZWyE8q',
  },
  CONSULT_FORM_PAGE: {
    development: '2006775109-VKZWyE8q',
    production: '2006775109-VKZWyE8q',
  },
}
